module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_0.ae01ced8.png";